import { toast } from "react-toastify";
import { toastOptions } from '../data/toastOptions';

type FormatResponseDataProps = {
    responseData: any,
    requestKey: string
}

// format response function to avoid nested data nodes
export const fomratResponseData = ({ responseData, requestKey }: FormatResponseDataProps) => {
    if (responseData) {
        try {
            // Get error data
            if (responseData.data.errors) {
                toast.error(`Error fetching ${requestKey} data`, {
                    ...toastOptions,
                    toastId: "FetchErrorToast",
                });
                return;

            // Get data successfully
            } else if (responseData?.data?.data) {
                return responseData?.data.data[requestKey];
            }
        } catch (error) {
            console.error(error)
        }
    }
}